export default "__VITE_ASSET__DGVyvwpj__"